import { useEffect } from "react";
import styled from "styled-components";

import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import SectionTitle from "components/text/SectionTitle";
import ContestDataContainer from "./ContestDataContainer";
import ContestResultsContainer from "./ContestResultsContainer";

const Contest = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

export default () => {
  // set page Title
  useEffect(() => {
    document.title = "Contest | Scalelup";
  }, []);

  return (
    <Layout>
      <Contest>
        <PageTitle>Contest</PageTitle>
        <ContestDataContainer />
        <SectionTitle>Results of the Latest Contest</SectionTitle>
        <ContestResultsContainer />
      </Contest>
    </Layout>
  );
};
